import React from 'react'
import { useStore } from '../../../../../../hooks/useStore'
import CircularButton from '../../../../../general/buttons/circular-button/CircularButton'

const ShareBackButton = () => { 
    const {uiStore: {hideShareCard}} = useStore()
    return (
        <CircularButton 
            bgColor='#aaa' 
            size={32} 
            onClick={hideShareCard}
            action="Back to list"
        >
            
            <svg  viewBox="0 0 32 25">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-1287.000000, -3398.000000)">
                        <g transform="translate(1287.000000, 3396.000000)">
                            <g transform="translate(14.500000, 14.500000) rotate(90.000000) translate(-14.500000, -14.500000) " fill="#000000">
                                <path d="M24.7530483,9.0753788 L24.7530483,22.7530483 C24.7530483,23.8576178 23.8576178,24.7530483 22.7530483,24.7530483 L9.0753788,24.7530483 C7.9708093,24.7530483 7.0753788,23.8576178 7.0753788,22.7530483 C7.0753788,22.2226153 7.28609248,21.7139075 7.66116524,21.3388348 L21.3388348,7.66116524 C22.1198833,6.88011665 23.3862133,6.88011665 24.1672619,7.66116524 C24.5423346,8.03623799 24.7530483,8.54494582 24.7530483,9.0753788 Z" id="Rectangle-Copy-5" transform="translate(14.500000, 14.500000) rotate(45.000000) translate(-14.500000, -14.500000) "></path>
                            </g>
                            <line x1="9" y1="14.5" x2="29" y2="14.5" id="Path-19" stroke="#000000" strokeWidth="5" strokeLinecap="round"></line>
                        </g>
                    </g>
                </g>
            </svg>

            <style jsx>{`
                svg {
                    height: 12px;
                }
            `}</style>
        </CircularButton>
    )
}   


export default ShareBackButton